import { render, staticRenderFns } from "./EditModbusParameter.vue?vue&type=template&id=39324d53"
import script from "./EditModbusParameter.vue?vue&type=script&lang=js"
export * from "./EditModbusParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports